import React, { Component } from 'react';
import styled from 'styled-components';
import Alert from '../../components/Alert';
import { colors } from '../../styles/colors';
import FlightSummary from '../../components/FlightSummary';
import FLIGHT_STATUS from '../../consts/FLIGHT_STATUS';
import Button from '../../components/Button';
import { devices } from '../../styles/breakpoints';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 16px;

  @media ${devices.desktop} {
    max-width: 1170px;
    margin: 0 auto;
  }
`;

const ReservationCodeContainer = styled.div`
  font-size: 14px;
  color: ${colors.GRAY_DARKEST};
  margin-top: 18px;
  margin-bottom: 4px;

  @media ${devices.desktop} {
    font-size: 20px;
  }
`;

const ReservationCode = styled.span`
  font-weight: bold;
`;

const BlueText = styled.p`
  font-size: 16px;
  color: ${colors.BRAND_PRIMARY};

  @media ${devices.desktop} {
    font-size: 20px;
    line-height: 24px;
  }
`;

const ActionsContainer = styled.div`
  position: fixed;
  bottom: 0px;
  width: 100%;
  left: 0px;
  padding: 16px 16px 0;
  background-color: white;

  @media ${devices.desktop} {
    position: relative;
    width: 290px;
    margin: 0 auto;
    background-color: none;
    box-shadow: none;
  }
`;

const WrapperFlex = styled.div`
  @media ${devices.desktop} {
    display: flex;
  }
`;

const RightColumn = styled.div`
  @media ${devices.desktop} {
    flex: 1;
    max-width: 500px;
    text-align: center;

    p {
      max-width: 332px;
      margin: 0 auto 24px;
    }
  }
`;

const LeftColumn = styled.div`
  @media ${devices.desktop} {
    max-width: 670px;
    flex: 1;
  }
`;

export default class FlightConfirmation extends Component {
  _checkIn = () => {
    const { location } = this.props;
    const BASE_URL = process.env.REACT_APP_WEBCHECKIN_URL + location.state.pnr;
    const win = window.open(BASE_URL, '_blank');
    win.focus();
  };

  render() {
    const { location } = this.props;

    return (
      <Container>
        <Alert success />
        <ReservationCodeContainer>
          Código da Reserva:{' '}
          <ReservationCode>{location.state.pnr}</ReservationCode>
          <br />
          <br />
        </ReservationCodeContainer>
        <WrapperFlex>
          <LeftColumn>
            <FlightSummary
              flight={location.state.flight}
              type={FLIGHT_STATUS.CONFIRMED}
            />
          </LeftColumn>

          <RightColumn>
            <BlueText>
              Agora você precisa fazer novamente o Check-in do seu voo e
              escolher seus novos assentos.
            </BlueText>
            <ActionsContainer>
              <Button primary onClick={this._checkIn}>
                Fazer check-in
              </Button>
            </ActionsContainer>
          </RightColumn>
        </WrapperFlex>
      </Container>
    );
  }
}
